<div class="container py-5 bg-star">
    <div class="row">
        <div class="col-md-6 m-auto">
            <div class="signup-form">
                <h5 class="mb-4">Reset Password</h5>
                <form>
                    <div class="form-group">
                        <label for="emailInput" class="form-label">Your Email address</label>
                        <input type="email" class="form-control" (change)="removeErrors()" [(ngModel)]="email" name="email" id="emailInput">
                        <div class="invalid-feedback d-block"
                            *ngIf="emailerror">
                            Please fill valid email.
                        </div>
                    </div>
                    <div class="form-group" *ngIf="otpsent">
                        <label for="" class="form-label">New Password:</label>
                        <input type="text" class="form-control" (change)="removeErrors()" [(ngModel)]="password" name="password">
                        <div class="invalid-feedback d-block"
                        *ngIf="passworderror">
                            Please fill 8 character long password.
                        </div>
                    </div>
                    <div class="form-group" *ngIf="otpsent">
                        <label for="" class="form-label">PIN:</label>
                        <input type="text" class="form-control" (change)="removeErrors()" [(ngModel)]="otp" name="otp">
                        <div class="invalid-feedback d-block"
                            *ngIf="otperror">
                            Invalid PIN.
                        </div>
                    </div>
                    
                    <div class="d-flex justify-content-end mt-3" *ngIf="!otpsent">
                        <button class="btn btn-gold mt-2 ml-auto" (click)="sendOtp()">Send PIN <i *ngIf="sendingotp" class="fa fa-spinner fa-spin"></i></button>
                    </div>
                    
                    <div class="d-flex justify-content-end mt-3" *ngIf="otpsent">
                        <button class="btn btn-gold me-3 mt-2" (click)="sendOtp()" [disabled]="time">Resend PIN <span *ngIf="time">{{time}}</span> <i *ngIf="sendingotp" class="fa fa-spinner fa-spin"></i></button><button class="btn btn-gold mt-2 ml-auto" (click)="changePassword()">Change Password <i *ngIf="formSubmitting" class="fa fa-spinner fa-spin"></i></button>
                    </div>
                </form>
            </div>
        </div>
    </div>


</div>